import React from 'react';
import { Table, Input, Button, Space, DatePicker, Tag, Modal, Tooltip } from 'antd';
import { DownloadOutlined, EyeOutlined, DeleteOutlined, ExperimentOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

const { Search } = Input;
const { RangePicker } = DatePicker;

const confirmDelete = () => {
  Modal.confirm({
    title: 'Confirm Deletion',
    content: 'Are you sure you want to permanently delete this data? This action cannot be undone.',
    okText: 'Delete',
    okType: 'danger',
    onOk() {
      console.log('Data deleted');
      // Add actual deletion logic here
    },
  });
};

const columns = [
  { title: 'Task ID', dataIndex: 'taskId', key: 'taskId' },
  { title: 'Tenant', dataIndex: 'tenant', key: 'tenant' },
  { title: 'Package Name', dataIndex: 'packageName', key: 'packageName' },
  { title: 'SHA256', dataIndex: 'sha256', key: 'sha256', render: (sha:string) => `${sha.substring(0, 12)}...`},
  { title: 'Submission Time', dataIndex: 'submissionTime', key: 'submissionTime' },
  { title: 'Status', dataIndex: 'status', key: 'status', render: (status:string) => <Tag color={status === 'Success' ? 'green' : 'red'}>{status}</Tag>},
  {
    title: 'Actions',
    key: 'actions',
    render: (text: any, record: any) => (
      <Space>
        <Tooltip title="View Report">
            <Link to={`/data-management/report/${record.taskId}`}>
                <Button icon={<EyeOutlined />} size="small" />
            </Link>
        </Tooltip>
        <Tooltip title={record.hasAdvancedReport ? "View Advanced Report" : "No advanced report available"}>
            <Link to={record.hasAdvancedReport ? `/advanced-report/${record.taskId}` : "#"}>
                <Button 
                    icon={<ExperimentOutlined />} 
                    size="small" 
                    disabled={!record.hasAdvancedReport}
                />
            </Link>
        </Tooltip>
        <Tooltip title="Download Data">
            <Button icon={<DownloadOutlined />} size="small" />
        </Tooltip>
        <Tooltip title="Delete Data">
            <Button icon={<DeleteOutlined />} size="small" danger onClick={confirmDelete} />
        </Tooltip>
      </Space>
    ),
  },
];

const data = [
  {
    key: '1',
    taskId: 'task-xyz-123',
    tenant: 'Customer Alpha',
    packageName: 'com.example.evilapp',
    sha256: 'a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2',
    submissionTime: '2025-11-10 14:55:00',
    status: 'Success',
    hasAdvancedReport: true,
  },
  {
    key: '2',
    taskId: 'task-abc-456',
    tenant: 'Customer Beta',
    packageName: 'com.another.app',
    sha256: 'f6e5d4c3b2a1f6e5d4c3b2a1f6e5d4c3b2a1f6e5d4c3b2a1f6e5d4c3b2a1f6e5',
    submissionTime: '2025-11-10 09:30:12',
    status: 'Failed',
    hasAdvancedReport: false,
  },
];

const DataManagementPage = () => {
  return (
    <div>
      <Space style={{ marginBottom: 16 }}>
        <Search placeholder="Search by Task ID, Package Name, Hash..." style={{ width: 400 }} />
        <RangePicker showTime />
        <Button type="primary">Search</Button>
      </Space>
      <Table columns={columns} dataSource={data} />
    </div>
  );
};

export default DataManagementPage;
